<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <template v-if="warning.show">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Atenção!</h4>
                        <p class="mb-0">{{warning.message}}</p>
                        <hr />
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Esporte</div>
                                </div>
                                <select class="form-control" v-model="sport">
                                    <option value="1" :selected="sport == 1">Futebol</option>
                                    <option value="2" :selected="sport == 2">Basquete</option>
                                    <option value="3" :selected="sport == 3">Lutas</option>
                                    <option value="4" :selected="sport == 4">Hóquei</option>
                                    <option value="5" :selected="sport == 5">Voleibol</option>
                                    <option value="6" :selected="sport == 6">Tênis</option>
                                    <option value="7" :selected="sport == 7">E-Sports</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Nova busca</div>
                                </div>
                                <input class="form-control" type="date" v-model="date" @change="listEvents">
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="w-100 mb-3">
                        <div class="btn-group w-100 mb-3" role="group" aria-label="Button group with nested dropdown">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click.prevent="sport = 1" :class="{'active': sport == 1}">
                                <i class="fas fa-futbol mr-2" v-show="platform == 'desktop'"></i>Futebol
                                <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="sport == 1 && events.length > 0">{{events.length}}</span>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javscript:void(0);" @click="search = ''">Todos</a>
                                    <a class="dropdown-item" href="javscript:void(0);" @click="search = '*'" :class="{'active': search == '*'}">Pendente</a>
                                </div>
                            </button>
                            <button type="button" class="btn btn-secondary" @click.prevent="sport = 2" :class="{'active': sport == 2}" :disabled="sport == 2">
                                <i class="fas fa-basketball-ball mr-2" v-show="platform == 'desktop'"></i>Basquete
                                <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="sport == 2 && events.length > 0">{{events.length}}</span>
                            </button>
                            <button type="button" class="btn btn-secondary" @click.prevent="sport = 3" :class="{'active': sport == 3}" :disabled="sport == 3">
                                <i class="fas fa-boxing-glove mr-2" v-show="platform == 'desktop'"></i>Lutas
                                <span class="badge badge-warning float-right" :class="{'w-100': platform == 'mobile', 'mt-1': platform == 'desktop'}" v-show="sport == 3 && events.length > 0">{{events.length}}</span>
                            </button>
                            <div class="btn-group" role="group">
                                <button id="btnGroupDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v mr-2"></i>Mais
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="sport = 4"><i class="fas fa-hockey-puck mr-2"></i>Hóquei</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="sport = 5"><i class="fas fa-volleyball-ball mr-2"></i>Voleibol</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="sport = 6"><i class="fas fa-tennis-ball mr-2"></i>Tênis</a>
                                    <a class="dropdown-item" href="javascript:void(0);" @click.prevent="sport = 7"><i class="fas fa-gamepad-alt mr-2"></i>E-Sports</a>
                                </div><!-- /dropdown-menu -->
                            </div><!-- /btn-group -->
                        </div><!-- /btn-group -->
                        <div class="row" :class="{'d-contents w-100': platform == 'mobile'}">
                            <div class="col" :class="{'d-block w-100 p-0 mb-3': platform == 'mobile'}">
                                <input class="form-control" type="text" v-model="search" placeholder="Buscar evento...">
                            </div>
                            <div class="col" :class="{'d-block w-100 p-0': platform == 'mobile'}">
                                <input class="form-control" type="date" v-model="date">
                            </div>
                        </div>
                    </div>
                    <div class="clearfix">
                        <template v-if="filteredListEvents.length == 0 && search && !loading">
                            <div class="alert alert-warning" role="alert">
                                <h4 class="alert-heading">Ops, nada encontrado!</h4>
                                <p class="mb-0">Não encontramos nenhum evento com o nome <strong>{{ search }}</strong>.</p>
                            </div>                       
                        </template>
                        <template v-else>
                            <collection-cluster data-theme="dark" v-bind="collection" :items="filteredListEvents" :style="{height: screen_innerHeight + 'px'}" :class="{'desktop pr-1': platform == 'desktop'}">
                                <div class="collection-cluster-item w-100" slot="item" slot-scope="{ cell, item }" :key="cell.index" :ref="item._id">
                                    <template v-if="cell.index == 0">
                                        <div class="row bg-warning p-2 m-0">
                                            <div class="col-12 text-center text-dark text-truncate">{{item.liga}}</div>
                                        </div>
                                    </template>
                                    <template v-else-if="item['liga_id'] !== filteredListEvents[cell.index - 1]['liga_id']">
                                        <div class="row bg-warning p-2 m-0">
                                            <div class="col-12 text-center text-dark text-truncate">{{item.liga}}</div>
                                        </div>
                                    </template>
                                    <div class="row p-2 m-0" :class="{'bg-danger': horario > addMinutes(item.ultima_atualizacao)}">
                                        <div class="col-auto mt-1 text-truncate text-white" :class="{'d-block w-100 text-center pt-1 pb-2 border-bottom border-secondary text-danger': platform == 'mobile'}" :style="{color: (horario > addMinutes(item.ultima_atualizacao) && platform == 'mobile' ? '#fff!important' : '')}">{{item.horario | formateDate}}</div>
                                        <div class="col-auto mt-1" :class="{'no-transmission': item.transmissao_fonte == 0, 'transmission': item.transmissao_fonte != 0, 'd-block w-100 text-center pt-1 pb-2 border-bottom border-secondary': platform == 'mobile'}">
                                            <i class="fas fa-signal-stream"></i>
                                        </div>
                                        <div class="w-100" v-if="platform == 'mobile'"></div>
                                        <div class="col mt-1 text-truncate" :class="{'d-block w-100 text-center': platform == 'mobile'}">{{item.time_casa}}</div>
                                        <div class="w-100" v-if="platform == 'mobile'"></div>
                                        <div class="col mt-1 text-truncate" :class="{'d-block w-100 text-center mb-1': platform == 'mobile'}">{{item.time_fora}}</div>
                                        <div class="col-auto" :class="{'d-block w-100 text-center pb-2': platform == 'mobile'}">
                                            <button type="button" class="btn btn-primary btn-sm" :class="{'btn-block': platform == 'mobile'}" @click="searchByGoogle(item.time_casa, item.time_fora)">
                                                <i class="fas fa-search mr-2"></i>Pesquisar
                                            </button>
                                        </div>
                                        <div class="col-auto" :class="{'d-block w-100 text-center pb-2': platform == 'mobile'}">
                                            <div class="dropdown">
                                                <button class="btn btn-secondary btn-sm dropdown-toggle" :class="{'btn-block': platform == 'mobile'}" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Opções</button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <h6 class="dropdown-header text-center">
                                                        <small class="text-uppercase text-success">Atualização</small>
                                                        <div class="row mt-3">
                                                            <div class="col text-left text-info pl-0 pr-0 small">IN:</div>
                                                            <div class="col text-right text-info pr-0 small">{{filteredListEvents[cell.index].inicio_atualizacao | formateDateAndHourSeconds}}</div>
                                                            <div class="w-100 dropdown-divider"></div>
                                                            <div class="col text-left text-info pl-0 pr-0 small">FN:</div>
                                                            <div class="col text-right text-info pr-0 small">{{filteredListEvents[cell.index].ultima_atualizacao | formateDateAndHourSeconds}}</div>
                                                            <div class="w-100 dropdown-divider"></div>
                                                            <div class="col text-left text-info pl-0 pr-0 small">PX:</div>
                                                            <div class="col text-right text-info pr-0 small">{{filteredListEvents[cell.index].inicio_atualizacao | formateDateAddMinutes}}</div>
                                                        </div>
                                                    </h6>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="javascript:;" :class="{'disabled': block}" @click="editEvent(cell.index)">Editar</a>
                                                    <a class="dropdown-item" href="javascript:;" :class="{'disabled': block}" @click="editOdds(item._id)">Cotações</a>
                                                    <a class="dropdown-item" href="javascript:;" :class="{'disabled': block}" @click="deleteEvent(item)">Excluir evento</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="javascript:;" :class="{'disabled': block}" @click="removeEvent(item._id, 'nao')">Remover</a>
                                                    <a class="dropdown-item" href="javascript:;" :class="{'disabled': block}" @click="removeEvent(item._id, 'sim')">Remover e ocultar</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="javascript:;" :class="{'disabled': block}" @click="clearCache(item)">Limpar cache</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div><!-- /row -->
                            </collection-cluster>
                        </template>
                    </div>
                </template>
            </div>
            <modal name="edit-event" :width="platform == 'desktop' ? 600 : screen_w" :height="platform == 'desktop' ? 500 : screen_h" :adaptive="true" :classes="['modal-dark','modal-edit-dark']" @before-open="modalOpen = true" @before-close="modalOpen = false">
                <template v-if="Object.keys(modalEditEvent).length">
                    <header class="modal-edit-header" style="max-height: 62.06px;">
                        <div class="row">
                            <div class="col-8 text-light text-truncate text-uppercase" style="position: relative;bottom: 10px;">
                                <div class="d-flex flex-column">
                                    <span class="mr-1">Editar evento</span>
                                    <span class="text-warning text-truncate">{{ filteredListEvents[modalEditEvent.index].time_casa }} x {{ filteredListEvents[modalEditEvent.index].time_fora }}</span>
                                </div>
                            </div>
                            <div class="col-4 text-right">
                                <div class="d-flex align-items-center justify-content-end flex-wrap">
                                    <button class="btn btn-sm btn-success" @click="saveEditions(modalEditEvent.index)">
                                        <template v-if="platform == 'desktop'">
                                            <i class="fas fa-save mr-2"></i>Salvar
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-save"></i>
                                        </template>
                                    </button>
                                    <div class="modal-edit-close ml-3" role="button" @click="$modal.hide('edit-event')">
                                        <i class="fal fa-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="modal-edit-scroll-area">
                        <div class="w-100">
                            <div class="card card-body rounded-0 p-3">
                                <div class="form-group">
                                    <label class="text-dark" :for="`srv-id-${modalEditEvent.index}`">ID</label>
                                    <input type="text" class="form-control" :id="`srv-id-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index]._id" @click="copyClipboard($event)" readonly autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`api-${modalEditEvent.index}`">API-ID</label>
                                    <input type="number" class="form-control" :id="`api-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].api_id" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`api-alternative-${modalEditEvent.index}`">API-AL</label>
                                    <input type="text" class="form-control" :id="`api-alternative-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].api_alternativa" :readonly="block" autocomplete="off" spellcheck="false" @keyup="allowLettersAndNumbers">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`server-${modalEditEvent.index}`">Servidor</label>
                                    <input type="text" class="form-control" :id="`server-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].servidor" :readonly="block"  autocomplete="off" spellcheck="false" @keyup="allowLettersAndNumbers">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`streaming-id-${modalEditEvent.index}`">Transmissão</label>
                                    <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].transmissao_fonte" name="channels" :id="`streaming-id-${modalEditEvent.index}`" :readonly="block">
                                        <option value="1" :selected="filteredListEvents[modalEditEvent.index].transmissao_fonte == 1">Link</option>
                                        <option value="0" :selected="filteredListEvents[modalEditEvent.index].transmissao_fonte == 0">Nenhuma</option>
                                        <optgroup label="Canais de TV">
                                            <option v-for="(channel, key) in channels" :value="channel.id" :key="key" :selected="filteredListEvents[modalEditEvent.index].transmissao_fonte == channel.id">
                                                {{channel.channel}}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="form-group" v-show="filteredListEvents[modalEditEvent.index].transmissao_fonte == 1">
                                    <label class="text-dark" :for="`streaming-link-${modalEditEvent.index}`">Link da transmissão</label>
                                    <input type="text" class="form-control" :id="`streaming-link-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].transmissao_url" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`league-${modalEditEvent.index}`">Liga</label>
                                    <input type="text" class="form-control" :id="`league-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].liga" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`league-id-${modalEditEvent.index}`">Liga-ID</label>
                                    <input type="text" class="form-control" :id="`league-id-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].liga_id" :readonly="block"  autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`team-home-${modalEditEvent.index}`">Mandante</label>
                                    <input type="text" class="form-control" :id="`team-home-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].time_casa" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`team-away-${modalEditEvent.index}`">Visitante</label>
                                    <input type="text" class="form-control" :id="`team-away-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].time_fora" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`date-${modalEditEvent.index}`">Data do evento</label>
                                    <input type="date" class="form-control" :id="`date-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].data" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`hour-${modalEditEvent.index}`">Hora do evento</label>
                                    <input type="time" class="form-control" :id="`hour-${modalEditEvent.index}`" v-model="filteredListEvents[modalEditEvent.index].hora" :readonly="block" autocomplete="off" spellcheck="false">
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`status-${modalEditEvent.index}`">Situação do evento</label>
                                    <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].status" :id="`status-${modalEditEvent.index}`" :disabled="block">
                                        <option value="0" :selected="filteredListEvents[modalEditEvent.index].status == 0">Andamento</option>
                                        <option value="3" :selected="filteredListEvents[modalEditEvent.index].status == 3">Adiado</option>
                                        <option value="4" :selected="filteredListEvents[modalEditEvent.index].status == 4">Cancelado</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`show-${modalEditEvent.index}`">Exibir evento</label>
                                    <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].pre_jogo" :id="`show-${modalEditEvent.index}`" :disabled="block">
                                        <option value="1" :selected="filteredListEvents[modalEditEvent.index].pre_jogo == 1">Sim</option>
                                        <option value="2" :selected="filteredListEvents[modalEditEvent.index].pre_jogo == 2">Não</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`block-${modalEditEvent.index}`">Bloquear evento</label>
                                    <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].bloqueado" :id="`block-${modalEditEvent.index}`" :disabled="block">
                                        <option value="1" :selected="filteredListEvents[modalEditEvent.index].bloqueado == '1'">Sim</option>
                                        <option value="2" :selected="filteredListEvents[modalEditEvent.index].bloqueado == '2'">Não</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`correct-schedule-${modalEditEvent.index}`">Corrigir horário</label>
                                    <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].corrigir_horario" :id="`correct-schedule-${modalEditEvent.index}`" :disabled="block">
                                        <option value="sim" :selected="filteredListEvents[modalEditEvent.index].corrigir_horario == 'sim'">Sim</option>
                                        <option value="nao" :selected="filteredListEvents[modalEditEvent.index].corrigir_horario == 'nao'">Não</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`update-${modalEditEvent.index}`">Última atualização</label>
                                    <input class="form-control" type="text" :value="filteredListEvents[modalEditEvent.index].ultima_atualizacao | formateDateAndHour" readonly>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark" :for="`update-${modalEditEvent.index}`">Atualizar automaticamente</label>
                                    <select class="form-control" v-model="filteredListEvents[modalEditEvent.index].automatico" :id="`update-${modalEditEvent.index}`" :disabled="block">
                                        <option value="1" :selected="filteredListEvents[modalEditEvent.index].automatico == 1">Sim</option>
                                        <option value="2" :selected="filteredListEvents[modalEditEvent.index].automatico == 2">Não</option>
                                    </select>
                                </div>
                                <div class="row" :class="{'d-contents w-100': platform == 'mobile'}">
                                    <div class="col" :class="{'mb-3 p-0': platform == 'mobile'}">
                                        <button class="btn btn-block btn-success" @click="saveEditions(modalEditEvent.index)"><i class="fas fa-save mr-2"></i>Salvar alterações</button>
                                    </div>
                                    <div class="col" :class="{'p-0': platform == 'mobile'}" v-if="!block">
                                        <button class="btn btn-block btn-danger" @click="$modal.hide('edit-event')">
                                            <i class="fas fa-ban mr-2"></i>Cancelar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!--/scroll-->
                </template>
            </modal><!-- /modal-edit-event-->
            <modal name="edit-odds" :width="platform == 'desktop' ? 600 : screen_w" :height="platform == 'desktop' ? 500 : screen_h" :adaptive="true" :classes="['modal-dark','modal-edit-dark']" @before-open="modalOpen = true" @before-close="modalOpen = false">
                <template v-if="Object.keys(modal).length">
                    <header class="modal-edit-header">
                        <div class="row">
                            <div class="col-8 text-light text-uppercase mt-1">Editar odds</div>
                            <div class="col-4 text-right">
                                <div class="d-flex align-items-center justify-content-end flex-wrap">
                                    <button class="btn btn-sm btn-success" @click="saveOdds(modal)">
                                        <template v-if="platform == 'desktop'">
                                            <i class="fas fa-save mr-2"></i>Salvar
                                        </template>
                                        <template v-else>
                                            <i class="fas fa-save"></i>
                                        </template>
                                    </button>
                                    <div class="modal-edit-close ml-3" role="button" @click="$modal.hide('edit-odds')">
                                        <i class="fal fa-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div class="modal-edit-scroll-area">
                        <div class="container">
                            <div class="row bg-dark">
                                <div class="col text-center text-truncate text-white">
                                    <div>
                                        <img :src="`${image_server}/s/${imageShield(modal.partida.time_casa.nome)}`" @error="imageError($event, '/static/shield_default.png')" @load="imageCheck" :alt="modal.partida.time_casa.nome" border="0" width="48" height="48">
                                    </div>
                                    <div class="text-truncate">{{modal.partida.time_casa.nome}}</div>
                                </div>
                                <div class="col-auto text-center text-white">
                                    <div class="d-flex h-100 flex-column justify-content-center align-items-center">
                                        <i class="fal fa-times"></i>
                                    </div>
                                </div>
                                <div class="col text-center text-truncate text-white">
                                    <div>
                                        <img :src="`${image_server}/s/${imageShield(modal.partida.time_fora.nome)}`" @error="imageError($event, '/static/shield_default.png')" @load="imageCheck" :alt="modal.partida.time_fora.nome" border="0" width="48" height="48">
                                    </div>
                                    <div class="text-truncate">{{modal.partida.time_fora.nome}}</div>
                                </div>
                            </div>
                            <div class="row p-0" v-for="(item, index) in modal.odds" :key="index">
                                <template v-if="isArray(item.odd)">
                                    <template v-if="item.odd.length">
                                        <div class="col-12 p-0">
                                            <div class="row bg-warning p-2">
                                                <div class="col-12 mt-2 pb-2 text-dark text-uppercase text-truncate"><span class="badge badge-danger mr-2 align-text-bottom">{{item.cat_id}}</span>{{item.option}}</div>
                                            </div>
                                        </div>
                                        <div class="col-12 p-0" v-for="(option, key) in item.odd" :key="key">
                                            <!-- /OPÇÂO PLACAR -->
                                            <template v-if="item.id == 27 || item.id == 155">
                                                <div class="row rw">
                                                    <div class="col-8 mt-2 text-white text-truncate">
                                                        <template v-if="option.score_home > option.score_away">
                                                            Casa ({{option.score.replace('-',':')}})
                                                        </template>
                                                        <template v-if="option.score_home == option.score_away">
                                                            Empate ({{option.score.replace('-',':')}})
                                                        </template>
                                                        <template v-else-if="option.score_home < option.score_away">
                                                            Fora ({{option.score.replace('-',':')}})
                                                        </template>
                                                    </div>
                                                    <div class="col-4">
                                                        <div class="d-flex flex-column">
                                                            <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">$</div>
                                                            </div>
                                                                <input type="number" class="form-control" v-model="modal.odds[index].odd[key].odd" @keypress="updateValue($event)" autocomplete="off" spellcheck="false">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- /OPÇÂO DE JOGADOR -->
                                            <template v-else-if="item.id == 98 || item.id == 99 || item.id == 236">
                                                <div class="row rw">
                                                    <div class="col-8 mt-2 text-white text-truncate">{{option.player}}</div>
                                                    <div class="col-4">
                                                        <div class="d-flex flex-column">
                                                            <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">$</div>
                                                            </div>
                                                                <input type="number" class="form-control" v-model="modal.odds[index].odd[key].odd" @keypress="updateValue($event)" autocomplete="off" spellcheck="false">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- /OPÇÂO DE ESCANTEIOS MAIS/MENOS/EXATOS -->
                                            <template v-else-if="item.id == 100 || item.id == 101 || item.id == 102">
                                                <div class="row rw">
                                                    <div class="col-8 mt-2 text-white text-truncate">{{item.id == 100 ? 'Mais de ' : item.id == 101 ? 'Menos de ' : 'Exatos '}} {{option.handicap}}</div>
                                                    <div class="col-4">
                                                        <div class="d-flex flex-column">
                                                            <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">$</div>
                                                            </div>
                                                                <input type="number" class="form-control" v-model="modal.odds[index].odd[key].odd" @keypress="updateValue($event)" autocomplete="off" spellcheck="false">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- /OPÇÂO DE CARTÕES PARTIDA/CASA/FORA -->
                                            <template v-else-if="item.id == 123 || item.id == 124 || item.id == 125 || item.id == 126 || item.id == 127 || item.id == 128">
                                                <div class="row rw">
                                                    <div class="col-8 mt-2 text-white text-truncate">{{item.id == 123 || item.id == 125 || item.id == 127 ? 'Acima de ' : 'Abaixo de '}} {{option.handicap}}</div>
                                                    <div class="col-4">
                                                        <div class="d-flex flex-column">
                                                            <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">$</div>
                                                            </div>
                                                                <input type="number" class="form-control" v-model="modal.odds[index].odd[key].odd" @keypress="updateValue($event)" autocomplete="off" spellcheck="false">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- /OPÇÂO DE TOTAL DE PONTOS PARTIDA/CASA/FORA -->
                                            <template v-else-if="item.id == 215 || item.id == 216 || item.id == 217 || item.id == 218 || item.id == 219 || item.id == 220 || item.id == 235 || item.id == 236 || item.id == 237 || item.id == 238 || item.id == 239 || item.id == 240">
                                                <div class="row rw">
                                                    <div class="col-8 mt-2 text-white text-truncate">{{item.id == 215 || item.id == 217 || item.id == 219 || item.id == 235 || item.id == 237 || item.id == 239 ? 'Mais de ' : 'Menos de '}} {{option.handicap}}</div>
                                                    <div class="col-4">
                                                        <div class="d-flex flex-column">
                                                            <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">$</div>
                                                            </div>
                                                                <input type="number" class="form-control" v-model="modal.odds[index].odd[key].odd" @keypress="updateValue($event)" autocomplete="off" spellcheck="false">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="index == 0">
                                        <div class="col-12 p-0">
                                            <div class="row bg-warning p-2">
                                                <div class="col-12 mt-2 pb-2 text-dark text-uppercase text-truncate"><span class="badge badge-danger mr-2 align-text-bottom">{{item.cat_id}}</span>{{item.cat_name}}</div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="item.cat_name != modal.odds[index - 1].cat_name">
                                        <div class="col-12 p-0">
                                            <div class="row bg-warning p-2">
                                                <div class="col-12 mt-2 pb-2 text-dark text-uppercase text-truncate"><span class="badge badge-danger mr-2 align-text-bottom">{{item.cat_id}}</span>{{item.cat_name}}</div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="w-100">
                                        <div class="row">
                                            <div class="col-8 mt-2 text-white text-truncate">{{modal.odds[index].option}}</div>
                                            <div class="col-4">
                                                <div class="d-flex flex-column">
                                                    <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">$</div>
                                                    </div>
                                                        <input type="number" class="form-control" v-model="modal.odds[index].odd" @keypress="updateValue($event)" autocomplete="off" spellcheck="false">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </modal><!-- /modal-edit-odds-->
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import Vue from 'vue'
import {api} from '../api'
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import VModal from 'vue-js-modal'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CollectionCluster from 'vue-collection-cluster'


Vue.use(VModal)

const today = moment().tz('America/Recife').format('YYYY-MM-DD');

const heightAdjustMobile = 260;
const heightAdjustDesktop = 200;
const heightAdjust = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? heightAdjustMobile : heightAdjustDesktop;

export default {
    data() {
        return {
            sport: 1,
            modal: {},
            search: '',
            block: true,
            date: today,
            events: [],
            channels: [],
            modalEditEvent: {},
            warning: {
                show: false,
                message: ''
            },
            today: today,
            loading: false,
            modalOpen: false,
            collection: {
                heightType: 'automatic',
                // itemHeight: 46
            },
            screen_w: window.screen.width,
            screen_h: window.screen.height,
            horario: moment().tz('America/Recife').format(),
            image_server: 'https://static.betsnow.net/images',
            screen_innerHeight: window.innerHeight - heightAdjust,
            platform: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading,
        CollectionCluster
    },
    methods: {
        saveEditions(index) {

            try {

                const self = this;
                const event = self.filteredListEvents[index];

                self.$modal.hide('edit-event');

                if (event.liga.trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o nome da liga!',
                        'warning'
                    );
                } else if (event.time_casa.trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o nome do mandante!',
                        'warning'
                    );
                } else if (event.time_fora.trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe o nome do visitante!',
                        'warning'
                    );
                } else if (event.data.trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a data do evento!',
                        'warning'
                    );
                } else if (event.hora.trim() == '') {
                    Swal.fire(
                        'Atenção!',
                        'Informe a hora do evento!',
                        'warning'
                    );
                } else {

                    Swal.fire({
                        title: 'Salvar alterações',
                        html: `Você deseja mesmo salvar as alterações do evento <p class="mb-0"><b>${event.time_casa}</b> X <b>${event.time_fora}</b> ?</p>`,
                        showCancelButton: true,
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Cancelar',
                        confirmButtonText: 'Sim'
                    }).then((result) => {

                        if (result.value) {
                            
                            self.loading = true;
                            event.horario = moment([event.data, event.hora].join(' ')).tz('America/Recife').format();

                            api.post('editar-evento', {
                                evento: event 
                            }).then((response) => {
                                switch(response.data.result) {
                                    case 'success':
                                        Swal.fire(
                                            'Parabéns!',
                                            'As alterações foram salvas com sucesso!',
                                            'success'
                                        );
                                    break;
                                    default:
                                        Swal.fire(
                                            'Atenção',
                                            response.data.message,
                                            'warning'
                                        );
                                    break;
                                }
                            }).catch((error) => {
                                try {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[error.status]['message'],
                                        'warning'
                                    );
                                } catch(e) {
                                    Swal.fire(
                                        'Falha',
                                        self.network_erros[408]['message'],
                                        'warning'
                                    );
                                }
                            }).finally(() => {
                                self.loading = false;
                            });
                        }
                    });
                }
            } 
            catch(e) 
            {
                Swal.fire(
                    'Atenção!',
                    'O evento não está disponível, atualize a página e tente novamente!',
                    'warning'
                );
            }
        },
        listEvents() {

            const self = this;

            self.events = [];
            self.loading = true;
            self.modalEditEvent = {};
            self.warning.show = false;

            api.get(`eventos/${self.date}/${self.sport}`).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.channels = response.data.channels.sort((a, b) => {

                            if (self.removeAccents(a.channel) < self.removeAccents(b.channel)) return -1;
                            if (self.removeAccents(a.channel) > self.removeAccents(b.channel)) return 1;

                            return 0;
                        });
                        self.events = response.data.events.map((item) => {
                            return {
                                type: 'item',
                                _id: item._id,
                                api_id: item.api_id,
                                api_alternativa: item.api_alternativa,
                                servidor: item.servidor,
                                ativo: item.ativo,
                                status: item.status,
                                corrigir_horario: item.corrigir_horario,
                                automatico: item.automatico,
                                bloqueado: item.bloqueado,
                                pre_jogo: item.pre_jogo,
                                liga: item.liga,
                                liga_id: item.liga_id,
                                time_casa: item.time_casa,
                                time_fora: item.time_fora,
                                data: item.data,
                                hora: item.hora,
                                horario: item.horario,
                                transmissao_url: item.transmissao_url,
                                transmissao_fonte: item.transmissao_fonte,
                                inicio_atualizacao: item.inicio_atualizacao,
                                ultima_atualizacao: item.ultima_atualizacao,
                                contexto: (self.horario > self.addMinutes(item.ultima_atualizacao) ? '*' : '')
                            }
                        }).sort((a, b) => {

                            if (self.removeAccents(a.liga) < self.removeAccents(b.liga)) return -1;
                            if (self.removeAccents(a.liga) > self.removeAccents(b.liga)) return 1;

                            if (a.horario < b.horario) return -1;
                            if (a.horario > b.horario) return 1;

                            return 0;
                        });
                    break;
                    case 'nothing_found':
                        self.warning.show = true;
                        self.warning.message = 'Nenhum evento disponível';
                    break;
                    default:
                        self.warning.show = true;
                        self.warning.message = response.data.message;
                    break;
                }
            }).catch((error) => {
                try {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[error.status]['message'];
                } catch(e) {
                    self.warning.show = true;
                    self.warning.message = self.network_erros[408]['message'];
                }
            }).finally(() => {
                self.loading = false;
            });
        },
        removeEvent(id, display) {
            
            const self = this;
            
            Swal.fire({
                title: display == 'sim' ? 'Remove e ocultar evento' : 'Remover evento',
                html: display == 'sim' ? 'Você deseja remove e ocultar esse evento?' : 'Você deseja remove esse evento?',
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sim'
            }).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.get(`remove-evento/${id}/${display}`).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                self.report(response.data.results);
                            break;
                            default: 
                                Swal.fire(
                                    'Atenção',
                                    response.data.message,
                                    'warning'
                                );
                            break;
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'warning'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'warning'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            });
        },
        editOdds(id) {

            const self = this;

            self.loading = true;

            api.get(`odds/${id}`).then((response) => {
                switch(response.data.result) {
                    case 'success':
                        self.modal = response.data;
                        self.$modal.show('edit-odds', {
                            id: id
                        });
                    break;
                    default:
                        Swal.fire(
                            'Atenção!',
                            response.data.message,
                            'warning'
                        );
                    break;
                }
            }).catch((error) => {
                try {
                    Swal.fire(
                        'Falha',
                        self.network_erros[error.status]['message'],
                        'error'
                    );
                } catch(e) {
                    Swal.fire(
                        'Falha',
                        self.network_erros[408]['message'],
                        'error'
                    );
                }
            }).finally(() => {
                self.loading = false;
            });
        },
        editEvent(index) {
            try {
                this.modalEditEvent = {index};
                this.$modal.show('edit-event');
            } catch(e) {
                // window.console.log(e.message);
            }
        },
        deleteEvent(event) {

            try {

                const self = this;

                Swal.fire({
                    title: 'Confirmação',
                    html: `Você deseja mesmo excluir o evento? <hr /> <p class="font-weight-bold">${event.time_casa} X ${event.time_fora}</p> <hr /> Lembrando que após a confirmação, esse evento será excluído definitivamente.`,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sim'
                }).then((result) => {

                    if (result.value) {

                        self.loading = true;

                        api.delete(`delete-event/${event._id}`).then((response) => {
                            switch(response.data.result) {
                                case 'success':
                                    Swal.fire(
                                        'Parabéns!',
                                        'O evento foi excluído com sucesso',
                                        'success'
                                    );
                                break;
                                default:
                                    Swal.fire(
                                        'Atenção',
                                        response.data.message,
                                        'warning'
                                    );
                                break;
                            }
                        }).catch((error) => {
                            try {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[error.status]['message'],
                                    'warning'
                                );
                            } catch(e) {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[408]['message'],
                                    'warning'
                                );
                            }
                        }).finally(() => {
                            self.loading = false;
                        });
                    }
                });
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha',
                    e.message,
                    'error'
                );
            }
        },
        clearCache(event) {

            try {

                const self = this;

                Swal.fire({
                    title: 'Confirmação',
                    html: `Você deseja mesmo limpar cache do evento? <hr /> <p class="font-weight-bold">${event.time_casa} X ${event.time_fora}</p>`,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sim'
                }).then((result) => {

                    if (result.value) {

                        self.loading = true;

                        api.delete(`clear-cache/${event.api_id}/${event.data}`).then((response) => {
                            switch(response.data.result) {
                                case 'success':
                                    Swal.fire(
                                        'Parabéns!',
                                        'O cache foi limpo com sucesso',
                                        'success'
                                    );
                                break;
                                default:
                                    Swal.fire(
                                        'Atenção',
                                        response.data.message,
                                        'warning'
                                    );
                                break;
                            }
                        }).catch((error) => {
                            try {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[error.status]['message'],
                                    'warning'
                                );
                            } catch(e) {
                                Swal.fire(
                                    'Falha',
                                    self.network_erros[408]['message'],
                                    'warning'
                                );
                            }
                        }).finally(() => {
                            self.loading = false;
                        });
                    }
                });
            } 
            catch(e) 
            {
                Swal.fire(
                    'Falha',
                    e.message,
                    'error'
                );
            }
        },
        async saveOdds(event) {

            const self = this;
            const odds = await self.checkOdds();

            if (!odds) return;

            Swal.fire({
				title: 'Confirmação',
				html: `Você deseja mesmo alterar as odds do evento? <hr /> <p class="font-weight-bold">${event.partida.time_casa.nome} X ${event.partida.time_fora.nome}</p> <hr /> Lembrando que após a confirmação, esse evento não irá mais receber atualizações das odds automaticamente.`,
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'Cancelar',
				confirmButtonText: 'Sim'
			}).then((result) => {

                if (result.value) {

                    self.loading = true;

                    api.post('event/edit/odds', {
                        odds: odds,
                        id: event.id
                    }).then((response) => {
                        switch(response.data.result) {
                            case 'success':
                                Swal.fire(
                                    'Parabéns!',
                                    'As alterações foram salvas com sucesso!',
                                    'success'
                                );
                            break;
                            default:
                                Swal.fire(
                                    'Atenção!',
                                    response.data.message,
                                    'warning'
                                );
                        }
                    }).catch((error) => {
                        try {
                            Swal.fire(
                                'Falha',
                                self.network_erros[error.status]['message'],
                                'error'
                            );
                        } catch(e) {
                            Swal.fire(
                                'Falha',
                                self.network_erros[408]['message'],
                                'error'
                            );
                        }
                    }).finally(() => {
                        self.loading = false;
                    });
                }
            });
        },
        async checkOdds() {

            try {

                this.$modal.hide('edit-odds');

                for (let key in this.modal.odds) {
                    let item = this.modal.odds[key];

                    if (Array.isArray(item.odd)) {

                        if (item.odd.length) {

                            for (let j in item.odd) {
                                let option = item.odd[j];

                                if (option.odd == '' || option.odd < 1) {
                                    this.modal.odds[key].odd = '1.00';
                                }
                            }
                        }
                    }
                    else if(item.odd == '' || item.odd < 1)
                    {
                        this.modal.odds[key].odd = '1.00';
                    }
                }

                return this.modal.odds;
            } 
            catch(e) 
            {
                Swal.fire(
                    'Erro!',
                    'Preencha todos os campos, antes de salvar!',
                    'error'
                );
            }
        },
        report(results) {
            
            let html = '';
            let count = 1;

            for (const item of results) {
                html += `
                    <div class="row pb-3 border-bottom ${count > 1 ? 'pt-3' : ''}">
                        <div class="col text-truncate">${item.cliente}</div>
                        <div class="col text-truncate ${(item.message.includes('erro') || item.message.includes('failed')) ? 'text-danger' : 'text-success'}">${item.message}</div>
                    </div>
                `; count++;
            }

            Swal.fire(
                `Relatório (${count})`,
                html
            );
        },
        updateValue(event) {
           let value = event.target.value;

           value = value.replace(/\D/g,"");  
           value = value.replace(/[0-9]{12}/," ");  
           value = value.replace(/(\d{1})(\d{8})$/,"$1.$2");
           value = value.replace(/(\d{1})(\d{5})$/,"$1.$2");  
           value = value.replace(/(\d{1})(\d{1,2})$/,"$1.$2"); 
        
           event.target.value = value.replace(',','.');
        },
        allowLettersAndNumbers(event) {
            event.target.value = event.target.value.replace(/[^a-zA-Z0-9]+/gi,'');
        },
        allowLettersAndNumbersChar(event) {
            event.target.value = event.target.value.replace(/[^A-Za-z0-9/._-]+/gi,'');
        },
        isArray(obj) {
            return Array.isArray(obj);
        },
        removeAccents(str) {
            
            let string = str;
            let map = {a : /[\xE0-\xE6]/g, A : /[\xC0-\xC6]/g, e : /[\xE8-\xEB]/g, E : /[\xC8-\xCB]/g, i : /[\xEC-\xEF]/g, I : /[\xCC-\xCF]/g, o : /[\xF2-\xF6]/g, O : /[\xD2-\xD6]/g, u : /[\xF9-\xFC]/g, U : /[\xD9-\xDC]/g, c : /\xE7/g, C : /\xC7/g, n : /\xF1/g, N : /\xD1/g};

            for (let key in map) {
                 let rex = map[key];
                 string = string.replace(rex, key);
            }

            return string;
        },
        formateDate(date) {
            return moment(date).tz('America/Recife').format('YYYY-MM-DD');
        },
        addMinutes(date) {
            return moment(date).add(7, 'minutes').tz('America/Recife').format();
        },
        searchByGoogle(team_home, team_away) {
            window.open(`https://google.com/search?q=${encodeURIComponent(`${team_home} x ${team_away}`)}`, '_blank');
        },
        copyClipboard(event) {
            navigator.clipboard.writeText(event.target.value).then(() => {
                Swal.fire(
                    'Parabéns!',
                    'O <strong>ID</strong> foi copiado com sucesso!',
                    'success'
                )
            }, () => {
                Swal.fire(
                    'Erro!',
                    'Não foi possível copiar o <strong>ID</strong>!',
                    'error'
                )
            });            
        },
        imageError(event, image) {
            event.target.src = image;
        },
        imageShield(team) {
            try {
                return `${this.removeAccents(team).toLowerCase().trim().replace(/[^a-z-0-9\s]/g, '').replace(/\s/g, '-')}.png`;
            } catch(e) {
                return 'shield.png';
            }
        },
        imageCheck(event) {
            try {
                var w = event.target.naturalWidth;
                var h = event.target.naturalHeight;

                if (w == 1 && h == 1) {
                    event.target.src = 'shield.png';
                }
            } catch(e) {
                event.target.src = 'shield.png';
            }
        }
    },
    watch: {
        date() {
            this.listEvents();
        },
        sport() {
            this.listEvents();
        },
        modalOpen(value) {
            try {
                var body = document.getElementsByTagName('body')[0];

                if (value) {
                    body.classList.add('overflow-hidden');
                } else {
                    this.modal = {};
                    this.modalEditEvent = {};
                    body.classList.remove('overflow-hidden');
                }
            } catch(e) {
                window.console.log(e.message);
            }
        }
    },
    filters: {
        formateDate(date) {
            return moment(date).tz('America/Recife').format('DD/MM HH:mm');
        },
        formateDateAndHour(date) {
            return moment(date).tz('America/Recife').format('DD/MM/Y HH:mm:ss');
        },
        formateDateAndHourSeconds(date) {
            return moment(date).tz('America/Recife').format('DD/MM HH:mm:ss');
        },
        formateDateAddMinutes(date) {
            return moment(date).tz('America/Recife').add(7, 'minutes').format('DD/MM HH:mm:ss');
        }
    },
    computed: {
        filteredListEvents() {
            return this.events.filter((item) => {
                return this.removeAccents(item.liga).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim()) || this.removeAccents(item.time_casa).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim()) || this.removeAccents(item.time_fora).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim()) || this.removeAccents(item.contexto).toLowerCase().trim().includes(this.removeAccents(this.search).toLowerCase().trim())
            });
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.platform = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
        });
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
    created() {
        this.listEvents();
    }
}
</script>

<style scoped>
.col-sm {
    background-color: #ddd
}
.mt-3.mb-3 .row {
    margin-left: 0;
    margin-right: 0;
}
.row-head {
    padding: .75rem;
    background-color: #212529;
    color: #fff;
    vertical-align: bottom;
    text-align: center;
}
.row-league {
    padding: .75rem;
    background-color: #ffc107;
    color: #fff;
    vertical-align: bottom;
    text-align: center;
}
.row-event {
    padding: .75rem;
    color: #fff;
    vertical-align: bottom;
    text-align: center;
}
.row-event .col.text-truncate {
    position: relative;
    z-index: 0;
    top: 3px;
}
.row-event .col.text-truncate hr {
    border-top-color: #666;
}
.row.row-item {
    background-color: #212529;
}
.row.row-item:nth-of-type(odd) {
    background-color: rgba(255,255,255,.05);
}
.row-event.row-lock {
    background-color: rgba(255, 235, 59, 0.2784313725490196);
}
.d-contents {
    display: contents!important;
}
.v--modal-overlay {
  z-index: 99999999!important;
}
.modal-dark {
  background-color: rgb(51, 51, 51);
  text-align: left;
  border-radius: 3px;
  padding: 0;
}
.modal-dark.bg-brown {
  background-color: #3b3b3b !important
}
.modal-dark .modal-edit-header {
  width: 100%;
  padding: 1em;
  background-color: #222;
}
.modal-edit-dark .container .row,
.modal-edit-dark .container .row .w-100 .row,
.modal-edit-dark .container .row .col-12 .row {
  padding: .6em;
  background-color: #333;
}
.modal-edit-dark .container .row:nth-of-type(odd),
.modal-edit-dark .container .row:nth-of-type(odd) .row:not(.rw),
.modal-edit-dark .container .row .col-12:nth-of-type(odd) .row {
  background-color: #444;
}
.modal-edit-scroll-area {
    width: 100%;
    padding-bottom: 10px;
    overflow: hidden auto;
    height: calc(100% - 56px);
}
.modal-dark .modal-edit-scroll-area {
    background-color: #222;
}
.modal-edit-scroll-area::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background: #4b4b4b;
    border-radius: 0;
}
.modal-edit-scroll-area::-webkit-scrollbar-thumb {
    background: #373737;
    border-radius: 0;
}
.modal-edit-close {
    color: #fff;
}
.modal-edit-close:hover {
    color: #ddd;
}
.drop-left {
    margin-left: -100%!important;
}
.mw-0 {
    max-width: 0!important;
}
.collection-cluster {
    overflow-x: auto;
}
.collection-cluster.desktop::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.collection-cluster.desktop::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.collection-cluster.desktop::-webkit-scrollbar-thumb:active {
  background: #ddd;
}
.collection-cluster.desktop::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-radius: .25rem;
}
.collection-cluster.desktop::-webkit-scrollbar-track:hover {
  background: #666666;
}
.collection-cluster.desktop::-webkit-scrollbar-track:active {
  background: #333333;
}
.collection-cluster.desktop::-webkit-scrollbar-corner {
  background: transparent;
}
.collection-cluster[data-theme="dark"] .row .col {
    color: #fff;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item {
    vertical-align: top;
    border-top: 1px solid #454d55;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item {
    background-color: #343a40;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item:nth-of-type(odd) .row:not(.bg-warning) {
    background-color: rgba(255,255,255,.05);
}
.collection-cluster .collection-cluster-item .collapse .card {
    height: 300px;
    max-height: 300px;
    overflow-x: auto;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item .row:not(.bg-danger) .col-auto.transmission .fas.fa-signal-stream {
    color: #dc3545;
}
.collection-cluster[data-theme="dark"] .collection-cluster-item .row.bg-danger .col-auto.no-transmission .fas.fa-signal-stream,
.collection-cluster[data-theme="dark"] .collection-cluster-item .row:not(.bg-danger) .col-auto.no-transmission .fas.fa-signal-stream {
    color: #fff;
}
</style>